import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import "./App.css";
import { getAccount, connect, signMessage } from "@wagmi/core";
import { injected } from "@wagmi/connectors";
import { config } from "./config";
import { gameData } from "./lib/games/games.js";
import { useParams } from "react-router-dom";
import { useAccount } from "wagmi";
import ShooterGame from "./ShooterGame";
import MuteComponent from "./components/mute";
// window.setupPhaserGame = function (config) {
//   new window.Phaser.Game(config);
// };
let setupPhaserGame;
function Game() {
  const { address } = useAccount();
  let { id } = useParams();

  useEffect(() => {
    if (!id) return;
    const gameConfig = (gameData as any)[id];
    console.log("GAMMMCONFIG", id);
    if (gameConfig) {
      const el = window?.document?.querySelector("#game");
      if (!!el) {
        el.innerHTML = "";
      }

      new (window as any).Phaser.Game(gameConfig);
    }
    // new window.Phaser.Game(config);
    // setupPhaserGame = function () {
    //   console.log('COnfiggggg', config);
    //   config  = gameData[ searchParams.get('id')]
    //   new window.Phaser.Game(config);
    // };
  }, [address, id]);

  return (
    <div style={{ position: "relative" }}>
      <div
        id="game"
        style={{
          height: "1000px",
          marginTop: "50px",
        }}
      ></div>
      {/* <MuteComponent /> */}
    </div>
  );
}

export default Game;
